import { formatJPY } from "@juro/shared";
import type { WorkItemsSummary as Summary } from "../../api/workItemsApi.js";
import { PROFESSION_LABEL, PROFESSION_COLOR } from "../../lib/workItemConstants.js";

type Props = { summary: Summary };

export function WorkItemsSummary({ summary }: Props) {
  const { by_profession, totals } = summary;

  return (
    <div style={{
      background: "#f8fafc",
      border: "1px solid #e2e8f0",
      borderRadius: 10,
      padding: "12px 16px",
      marginTop: 12,
    }}>
      {/* 業種別小計 */}
      <div style={{ display: "flex", gap: 16, flexWrap: "wrap", marginBottom: 12 }}>
        {Object.entries(by_profession).map(([prof, data]) => (
          <div key={prof} style={{ fontSize: 12 }}>
            <span style={{
              display: "inline-block",
              background: `${PROFESSION_COLOR[prof]}18`,
              color: PROFESSION_COLOR[prof],
              borderRadius: 99,
              padding: "1px 8px",
              fontWeight: 600,
              marginRight: 4,
            }}>
              {PROFESSION_LABEL[prof] ?? prof}
            </span>
            <span style={{ color: "#475569" }}>
              {data.item_count}件 / 報酬 {formatJPY(data.fee_subtotal)}
              {data.pass_through > 0 && ` / 立替 ${formatJPY(data.pass_through)}`}
            </span>
          </div>
        ))}
      </div>

      {/* 全体集計 */}
      <div style={{
        display: "grid",
        gridTemplateColumns: "repeat(5, 1fr)",
        gap: 8,
        borderTop: "1px solid #e2e8f0",
        paddingTop: 10,
      }}>
        {[
          { label: "報酬合計",   value: totals.fee_subtotal,    color: "#0f172a" },
          { label: "立替合計",   value: totals.pass_through,     color: "#475569" },
          { label: "消費税",     value: totals.consumption_tax,  color: "#475569" },
          { label: "源泉所得税", value: -totals.withholding_tax, color: "#dc2626" },
          { label: "合計",       value: totals.grand_total,      color: "#0f766e" },
        ].map(({ label, value, color }) => (
          <div key={label} style={{ textAlign: "right" }}>
            <div style={{ fontSize: 10, color: "#94a3b8", fontWeight: 600, marginBottom: 2 }}>
              {label}
            </div>
            <div style={{ fontSize: 14, fontWeight: 700, color }}>
              {value < 0 ? `- ${formatJPY(-value)}` : formatJPY(value)}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
